import { Controller } from "@hotwired/stimulus";
import { parseValue } from "../lib/cart_helpers";

export default class extends Controller {
  static targets = ["subtotal"];

  static values = {
    price: Number,
    quantity: Number,
    subtotal: Number
  }

  connect() {
    this.calculate();
  }

  calculate() {
    this.subtotalValue = this.priceValue * this.quantityValue;
  }

  update({ currentTarget, params: { formatType, valueType } }) {
    this[`${valueType}Value`] = parseValue(currentTarget.value, formatType);
  }

  priceValueChanged = this.calculate
  quantityValueChanged = this.calculate

  subtotalValueChanged() {
    const formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

    if ("value" in this.subtotalTarget) {
      this.subtotalTarget.value = formatter.format(this.subtotalValue);
      this.subtotalTarget.dispatchEvent(new Event("input", { bubbles: true }));
    }
    else {
      this.subtotalTarget.innerText = formatter.format(this.subtotalValue);
    }
  }
}
